import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The rail's dark mode switch. Flips data-theme on <body>, where the dark
// colour tokens hang, and saves it in the theme cookie so the server paints
// the same theme on the next page. With no cookie yet, the first visit
// follows the computer's own light or dark setting.
export default class extends Controller {
  connect() {
    if (!document.cookie.split("; ").some((pair) => pair.startsWith("theme="))) {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      if (prefersDark) this.apply("dark")
    }
    this.syncSwitch()
  }

  toggle() {
    this.apply(document.body.dataset.theme === "dark" ? "light" : "dark")
  }

  apply(theme) {
    document.body.dataset.theme = theme
    document.cookie = `theme=${theme}; path=/; max-age=31536000; samesite=lax`
    // Cached snapshots still carry the old theme; drop them so a Back
    // visit does not flash the other one.
    Turbo.cache.clear()
    this.syncSwitch()
  }

  syncSwitch() {
    this.element.setAttribute("aria-checked", String(document.body.dataset.theme === "dark"))
  }
}
